import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area"
import { Tabs, TabsTrigger, TabsList } from "@/components/ui/tabs"
import { FC } from "react";

interface Props {
    selectedTab: string;
    handleFilterChange: (value: string) => void;
    totalOrders: number;
    statusMenu: {item: string, label: string}[];
}

const OrdersListHeader: FC<Props> = ({selectedTab, handleFilterChange, totalOrders, statusMenu}) => {
    return (
        <div className="flex flex-col gap-4 mb-1">
          <ScrollArea>
            <Tabs value={selectedTab} onValueChange={handleFilterChange}>
              <TabsList className="@4xl/main:flex">
              <TabsTrigger value="ALL">
                    ALL
                    <p className="ml-1 text-gray-500">
                      ({totalOrders})
                    </p>
                  </TabsTrigger>
                {statusMenu.map((item: any, index: number) => (
                  <TabsTrigger key={index} value={item.status}>
                    {item.label}
                    <p className="ml-1 text-gray-500">
                      ({item.total})
                    </p>
                  </TabsTrigger>
                ))}
              </TabsList>
            </Tabs>
            <ScrollBar orientation="horizontal" />
          </ScrollArea>
        </div>
    )
}

export default OrdersListHeader